module.exports = __webpack_public_path__ + "static/img/RE@2x.71ce65ea.jpg";